import { useAppSelector } from '../../../store/hooks';
import { getSearchTerm } from '../../utils/get-search-term/get-search-term';

export const useGetSearchTerm = (
  featureFilters: string,
  nameFilter: string
): string => {
  return useAppSelector(state =>
    getSearchTerm(state, featureFilters, nameFilter)
  );
};
